import { Injectable } from '@angular/core';
import { getAuth } from 'firebase/auth';
import { doc, getDoc, getFirestore } from 'firebase/firestore';
import { UserModel } from './user.model';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  async getUserData(): Promise<UserModel> {
    const user = getAuth().currentUser;
    if (!user) {
      throw new Error('Nenhum usuário está autenticado.');
    }

    const profile = await getDoc(doc(getFirestore(), 'users', user.uid));
    if (!profile.exists()) {
      throw new Error('O perfil desta conta não foi encontrado.');
    }

    return { ...profile.data(), uid: user.uid } as UserModel;
  }
}
